import TranslatePageStructureIntoReferencedFieldList from './TranslatePageStructureIntoReferencedFieldList';

const PopulateDynamicLists = (pageStructure, lists, key, value) => {

    let currentField;
    let  fields = TranslatePageStructureIntoReferencedFieldList(pageStructure);
    fields = fields.filter(f => f.Type === "dropdown" || f.Type === "filteredcombo" || f.Type === "combobox");

    for (const field of fields) {
        if (field.ParentList !== "" && field.ParentList  === key) {

            const list = lists.filter(l => l.Name.toLowerCase() === field.OptionsName.toLowerCase());

            const newValue = value === undefined || value.key === undefined ? value : value.value;
            field.Options = list[0].Options.filter(f => f.ParentKey === newValue).map((option) => { return {key: option.Key, text: option.Text, ParentKey: option.ParentKey}});

            field.value = null;
            currentField = field.Id
        }
        if (currentField !== undefined && field.ParentList === currentField) {
            field.value = null;
            field.Options = [];
            currentField = field.Id
        }
    }

}

export default PopulateDynamicLists;